import { ConfigurationError } from "../models";

/**
 * Prefer the user-facing message that the backend built. Both NetDocuments
 * (NetDocumentsApiConstants) and iManage (ImanageApiConstants) supply a full
 * Message on the configuration exception they throw. Falls back to a hard-coded
 * string only for DMS paths that haven't been migrated yet (e.g. SharePoint),
 * or to the supplied default for unknown errors.
 */
export class ErrorHandler {
    public HandleConfigurationErrorResponse(configurationError: ConfigurationError, defaultErrorMessage: string, onError: (errorMessage: string) => void): void {
        if (configurationError === null || configurationError === undefined) {
            onError(defaultErrorMessage);
            return;
        }

        const backendMessage = configurationError.Message;
        if (backendMessage) {
            onError(backendMessage);
            return;
        }

        switch (configurationError.Error) {
            case "InvalidDetailsException":
                onError("Invalid matter details. Unable to link.");
                break;
            case "MissingDetailsException":
                onError("Missing matter details. Unable to link.");
                break;
            case "InvalidFolderPropertyException":
                onError("Folder property was configured incorrectly. Unable to link.");
                break;
            case "InvalidFolderPropertyValueException":
                onError("Invalid alias or folder property. Unable to link.");
                break;
            case "FolderPropertyException":
                onError("Failed to set folder property. Unable to link.");
                break;
            default:
                onError(defaultErrorMessage);
                break;
        }
    }
}
